import ArtifactPage from '@/views/artifacts/ArtifactPage'

export default function ArtifactScreen() {
  return <ArtifactPage />
}
